module.exports = __webpack_public_path__ + "static/media/icon-student.c71513ea.svg";